import React from "react";
import Accordion from "react-bootstrap/Accordion";
import styles from "./CustomAccordion.module.css";

const JobDescriptionAccordion = ({ title, description }) => {
  return (
    <Accordion className="mt-3 cardShadow">
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <h5>
            <span className={`${styles.titleBar}`}>{title}</span>
          </h5>
        </Accordion.Header>

        <Accordion.Body>
          <div className="p-2">
            {Array.isArray(description) ? (
              description.map((item, i) => {
                // string support (old usage)
                if (typeof item === "string") {
                  return (
                    <p key={i} className="main_paragraph mb-2">
                      {item}
                    </p>
                  );
                }

                // object support (new usage)
                return (
                  <p
                    key={i}
                    className={`main_paragraph mb-2 ${item.bold ? styles.semiBold : ""}`}
                  >
                    {item.text}
                  </p>
                );
              })
            ) : (
              <p className="main_paragraph">{description}</p>
            )}
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default JobDescriptionAccordion;
